export default {
  fieldNames: {
    shortText: 'Brief text',
    extendedDescription: 'Extended description',
    colloquial1: 'Colloquial 1',
    colloquial2: 'Colloquial 2',
    colloquial3: 'Colloquial 3',
    colloquial4: 'Colloquial 4',
    colloquial5: 'Colloquial 5',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/createNewMaterials/Stages/description.js